import {
  getBaseURLForAPIBackend,
  getDefaultHeaders,
} from 'packages/lib/utils/fetch';
import { logError } from 'packages/lib/utils/logger';
import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';

// Oct-20-2025 - Used Gemini 2.5 Agent to assist with migration from Recoil to Jotai

type ImageResultParams = {
  logName: string;
  timestamp: number;
  channel: string;
};

export const imageResultSelectorFam = atomFamily(
  (params: ImageResultParams) =>
    atom(async (): Promise<string | null> => {
      const { logName, timestamp, channel } = params;
      if (!logName || !timestamp) return null;
      const qp = new URLSearchParams({
        logName,
        timestamp: timestamp.toString(),
        channel,
        downloadImage: 'true',
        inline: 'true',
        imageType: 'jpeg',
      } as Record<string, string>);
      const url = `${getBaseURLForAPIBackend(
        'omnitag'
      )}/media/fetch/image?${qp.toString()}`;
      try {
        const res = await fetch(url, {
          headers: {
            ...(await getDefaultHeaders()).headers,
          },
        });
        if (!res.ok) {
          return null;
        }
        return URL.createObjectURL(await res.blob());
      } catch (err) {
        logError(err);
        return null;
      }
    }),
  (a: ImageResultParams, b: ImageResultParams) =>
    a.logName === b.logName &&
    a.timestamp === b.timestamp &&
    a.channel === b.channel
);
